module.exports = __webpack_public_path__ + "img/smile.cbf2d51f.svg";